import React from 'react'
import { Table } from 'react-bootstrap'

import useTranslation from '@/Hooks/UseTranslation'
import { MsProjectPreview } from '@/Services/MsProjectImportService'
import TaskImportSourceViewer from '@/Components/TaskImportSourceViewer/TaskImportSourceViewer'

type Props = {
  costs: MsProjectPreview['costs']
  onGoToProgrammingRow: (uid: string) => void
}

const formatNumber = (value: number) => Number(value).toLocaleString(undefined, { maximumFractionDigits: 2 })

const CostsTab = ({ costs, onGoToProgrammingRow }: Props) => {
  const { t } = useTranslation()

  if (!costs.length) return <div className="text-muted py-3">{t('MS_PROJECT_IMPORTER:NoCosts')}</div>

  return (
    <>
      <h5>{t('MS_PROJECT_IMPORTER:CostsPreview')}</h5>
      <Table bordered hover size="sm" responsive className="ms-project-importer-costs">
        <thead>
          <tr>
            <th>{t('TASK_IMPORTER:TitleColumn')}</th>
            <th>{t('MS_PROJECT_IMPORTER:CostDescription')}</th>
            <th>{t('MS_PROJECT_IMPORTER:CostType')}</th>
            <th>{t('MS_PROJECT_IMPORTER:CostUnit')}</th>
            <th>{t('MS_PROJECT_IMPORTER:CostCrew')}</th>
            <th>{t('MS_PROJECT_IMPORTER:CostQuantity')}</th>
            <th>{t('MS_PROJECT_IMPORTER:CostUnitPrice')}</th>
            <th>{t('MS_PROJECT_IMPORTER:EstimatedCost')}</th>
            <th>{t('TASK_IMPORT_SOURCE:Column')}</th>
          </tr>
        </thead>
        <tbody>
          {costs.map((cost, index) => (
            <tr key={`${cost.taskUid}-${cost.resourceUid}-${index}`}>
              <td>
                <button
                  type="button"
                  className="ms-project-importer-task-link"
                  onClick={() => onGoToProgrammingRow(cost.taskUid)}
                >
                  {cost.taskId} - {cost.taskName}
                </button>
              </td>
              <td>{cost.description}</td>
              <td>{t(`MS_PROJECT_IMPORTER:CostType:${cost.type}`)}</td>
              <td>{cost.unit}</td>
              <td>{formatNumber(cost.crewNumber)}</td>
              <td>{formatNumber(cost.quantity)}</td>
              <td>{formatNumber(cost.unitPrice)}</td>
              <td>{formatNumber(cost.estimatedCost)}</td>
              <td>
                <TaskImportSourceViewer
                  source={cost.importSource}
                  taskName={cost.description}
                  recordLabelKey="TASK_IMPORT_SOURCE:Cost"
                  relatedTask={{
                    id: cost.taskId,
                    name: cost.taskName,
                    onSelect: () => onGoToProgrammingRow(cost.taskUid),
                  }}
                  compact
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  )
}

export default CostsTab
